var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMoreDetails = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#5D5CF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1424 18.0909H7.56037V6.63636H16.1424V18.0909ZM16.1424 5H7.56037C7.14654 5 6.74965 5.1724 6.45702 5.47928C6.1644 5.78616 6 6.20237 6 6.63636V18.0909C6 18.5249 6.1644 18.9411 6.45702 19.248C6.74965 19.5549 7.14654 19.7273 7.56037 19.7273H16.1424C16.5563 19.7273 16.9531 19.5549 17.2458 19.248C17.5384 18.9411 17.7028 18.5249 17.7028 18.0909V6.63636C17.7028 6.20237 17.5384 5.78616 17.2458 5.47928C16.9531 5.1724 16.5563 5 16.1424 5Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.22754H15",
    stroke: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.7275H15",
    stroke: "#5D5CF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.7275H15",
    stroke: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoreDetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more-details.f058c0e7.svg";
export { ForwardRef as ReactComponent };